import { Modal, Tab, Dropdown, Tooltip, Collapse, Popover } from 'bootstrap'
import { Spinner } from "./loandig"
import Swiper from 'swiper/bundle';
import Swal from 'sweetalert2'
import { Navigation, Pagination,Autoplay,EffectFade, } from 'swiper/modules';
import GLightbox from 'glightbox';
import  'fslightbox'
// import 'swiper/css/bundle';

window.Tooltip = Tooltip;


var banner = new Swiper(".banner", {
  autoplay: {
    delay: 3000,
    disableOnInteraction: true,
  },
  effect: "fade",
  loop:true,
  grabCursor: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '">' + (index + 1) + "</span>";
    },
  },
});

var swipermain = new Swiper(".mySwiper", {
  slidesPerView: 3,
  spaceBetween: 10,
  breakpoints: {
    300: {
      slidesPerView: 1,
      spaceBetween: 5,
    },
    640: {
      slidesPerView: 2,
      spaceBetween: 5,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 10,
    },
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

// swiper single
var swiperall = new Swiper(".singleslider", {
  slidesPerView: 3,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    300: {
      slidesPerView: 1,
      spaceBetween: 5,
    },
    640: {
      slidesPerView: 2,
      spaceBetween: 5,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 10,
    },
  },
});
// Swiper Luxury
var swiperlux = new Swiper(".sliderluxury", {
  slidesPerView: 3,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next1",
    prevEl: ".swiper-button-prev1",
  },
  breakpoints: {
    300: {
      slidesPerView: 1,
      spaceBetween: 5,
    },
    640: {
      slidesPerView: 2,
      spaceBetween: 5,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    1024: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
  },
});
// Swiper destinations
const destinations = new Swiper(".destinations", {
  slidesPerView: 3,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next1",
    prevEl: ".swiper-button-prev1",
  },
  breakpoints: {
    300: {
      slidesPerView: 1,
      spaceBetween: 5,
    },
    640: {
      slidesPerView: 2,
      spaceBetween: 5,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 10,
    },
  },
});

var swiperphotos = new Swiper(".swiperphotos", {
  slidesPerView: 1,
  navigation: {
    nextEl: ".swiper-button-next2",
    prevEl: ".swiper-button-prev2",
  },
});
// glightbox
const lightbox = GLightbox({
  selector: '.stLightbox',
  touchNavigation: true,
  loop: true,
  videosWidth: 960,
  closeOnOutsideClick: true, /// close cliked body
  autoplayVideos: true,
  svg: {

  }
});
// glightbox map
const lightboxmap = GLightbox({
  selector: '.lightboxmap',
  touchNavigation: true,
  loop: true,
  videosWidth: 960,
  closeOnOutsideClick: true, /// close cliked body
  autoplayVideos: true,
  svg: {

  }
});
const lightboxmap3 = GLightbox({
  selector: '.StLightbox3',
  touchNavigation: true,
  loop: true,
  videosWidth: 960,
  closeOnOutsideClick: true, /// close cliked body
  autoplayVideos: true,
  svg: {

  }
});
const StLightbox1 = GLightbox({
  selector: '.StLightbox1',
  touchNavigation: true,
  loop: true,
  videosWidth: 960,
  closeOnOutsideClick: true, /// close cliked body
  autoplayVideos: true,
});
// StLightbox2
const StLightbox2 = GLightbox({
  selector: '.StLightbox2',
  touchNavigation: true,
  loop: true,
  videosWidth: 960,
  closeOnOutsideClick: true, /// close cliked body
  autoplayVideos: true,
});
// glightbox home video
const homeligtbox = GLightbox({
  selector: '.homeligtbox',
  touchNavigation: true,
  loop: true,
  videosWidth: 960,
  closeOnOutsideClick: true, /// close cliked body
  autoplayVideos: true,
  svg: {

  }
});
// 
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl))

/**************  FORM SCRIPT ********************* */
// send function
const pearFormSend = (fromPear, load, url, pear_hook, action_contact, modalpear = null) => {
  fromPear.addEventListener('submit', async (e) => {
    e.preventDefault()
    load.active()
    const peardata = new FormData(fromPear);
    peardata.append('pear_hook', pear_hook);
    peardata.append('action', action_contact);
    fetch(url, { method: 'POST', body: peardata })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          load.hide()
          throw new Error('La solicitud no fue exitosa');
        }
      })
      .then(data => {
        if (data.success) {
          load.hide()
          fromPear.reset()
          if (modalpear) {
            modalpear.hide()
          }
          Swal.fire({
            title: data.data.title,
            text: data.data.message,
            icon: "success",
            showCancelButton: false,
            showConfirmButton: false,
            showCloseButton: true,
          });
        } else if (data.data.status == 500) {
          load.hide()
          Swal.fire({
            title: data.data.title,
            text: data.data.message,
            icon: "error",
            showCancelButton: false,
            showConfirmButton: false,
            showCloseButton: true,
          });
        } else {
          load.hide()
          fromPear.reset()
          Swal.fire({
            title: data.data,
            text: null,
            icon: "error",
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonText: 'Update',
            showCloseButton: true,
            confirmButtonColor: '#000', // Cambia esto al color que desees
            customClass: {
              confirmButton: ' btn-sm rounded-0 shadow-0' // Agrega aquí la clase personalizada que quieras
            }
          }).then((result) => {
            if (result.isConfirmed) {
              location.reload(); // Esto recarga la página
            }
          });

        }
      })
      .catch(error => {
        console.error('Error en la solicitud:', error);
        if (error && error.message) {
          console.error('Mensaje de error del servidor:', error.message);
        }
      });
  })
}
// form customize
const btnOpenCustomize = document.querySelector('#btn-customize');
const formCustomize = document.querySelector('#form_customize')
const loads = new Spinner({
  selector: ".loandig",
  width: 25,
  height: 25,
  text: "loandig..",
  color: "#d7b672",
  background: "#fff",
});
if (btnOpenCustomize) {
  const modalCustomize = new Modal('#customize', {
    keyboard: false
  })
  //  open modal  customize form
  btnOpenCustomize.addEventListener('click', (e) => {
    modalCustomize.show()
  })
  if (formCustomize) {
    pearFormSend(formCustomize, loads, PEARSCRIPTC.ajax_url, PEARSCRIPTC.pear_hook, PEARSCRIPTC.action_contactCustomize, modalCustomize)

  }

}
// form inquire now
document.addEventListener('DOMContentLoaded', () => {
  const loadspiner = new Spinner({
    selector: ".spiners",
    width: 25,
    height: 25,
    text: "loandig..",
    color: "#d7b672",
    background: "#fff",
  });
  const btnOpenInquire = document.getElementById('btninquireNow');
  const formInquire = document.querySelector('#forminquire')
  if (btnOpenInquire) {
    const modalInquire = new Modal('#modalInquire', {
      keyboard: false
    })
    btnOpenInquire.addEventListener('click', () => {
      modalInquire.show()
    })
    if (formInquire) {
      // loadspiner.active()
      pearFormSend(formInquire, loadspiner, PEARSCRIPTC.ajax_url, PEARSCRIPTC.pear_hook, PEARSCRIPTC.action_inquire, modalInquire)
    }
  }
})
// form contact
const spinercontact = new Spinner({
  selector: ".spinerscontact",
  width: 25,
  height: 25,
  text: "loandig..",
  color: "#d7b672",
  background: "#fff",
});
const formcontact = document.querySelector('#formcontact')
if (formcontact) {
  pearFormSend(formcontact, spinercontact, PEARSCRIPTC.ajax_url, PEARSCRIPTC.pear_hook, PEARSCRIPTC.action_contact, null)
}
/*************************** end forms ****************** */

/**************** script tabs single ********************/

var container = document.querySelector('.haader-content');
var menuItems = document.querySelectorAll('#navegation-content li');
var contents = document.querySelectorAll('.secciont-tab');

menuItems.forEach(function (item) {
  item.addEventListener('click', function (event) {
    var selectedItem = event.target;
    // console.log(selectedItem)
    var contentId = item.getAttribute('data-content');
    // console.log(contentId)
    // Remove active class from all menu items
    menuItems.forEach(function (item) {
      item.classList.remove('active');
    });

    // Add active class to the clicked menu item
    item.classList.add('active');
    //  console.log(contents);
    // Hide all contents
    contents.forEach(function (content) {
      content.classList.remove('active');
    });

    // Show the corresponding content
    var contentToShow = document.getElementById(contentId);
    contentToShow.classList.add('active');

    var selectedOffset = selectedItem.offsetLeft - container.offsetLeft + selectedItem.offsetWidth / 4;
    var scrollLeft = selectedOffset - container.offsetWidth / 4;

    // Smooth scroll animation
    container.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });
  });
});

window.addEventListener('wheel', function () {
  const scrollDistance = window.scrollY;
  const tabs = document.querySelectorAll('.TabLink');

  tabs.forEach(tab => {
    const sectionId = tab.getAttribute('href').substring(1);
    const section = document.getElementById(sectionId);

    if (section.offsetTop <= scrollDistance && section.offsetTop + section.offsetHeight > scrollDistance) {
      tab.parentElement.classList.add('active');
      centerTab(tab);
    } else {
      tab.parentElement.classList.remove('active');
    }
  });
});

function centerTab(tab) {
  const nav = document.querySelector('.haader-content');
  const tabWidth = tab.offsetWidth;
  const navWidth = nav.offsetWidth;
  const tabLeftOffset = tab.offsetLeft;

  const scrollLeft = tabLeftOffset - (navWidth - tabWidth) / 2;
  nav.scrollTo({
    left: scrollLeft,
    behavior: 'smooth'
  });

}
// touch scroll

document.addEventListener('DOMContentLoaded', () => {
  const box = document.querySelector('.haader-content');
  console.log(box);
  if (!box) return false;

  let isDown = false;
  let startX;
  let scrollLeft;

  box.addEventListener('mousedown', (e) => {
    isDown = true;
    startX = e.pageX - box.offsetLeft;
    scrollLeft = box.scrollLeft;
    box.style.cursor = 'grabbing';
  });

  box.addEventListener('mouseleave', () => {
    isDown = false;
    box.style.cursor = 'grab';
  });

  box.addEventListener('mouseup', () => {
    isDown = false;
    box.style.cursor = 'grab';
  });

  box.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - box.offsetLeft;
    const walkX = (x - startX) * 1; // Adjust scroll speed here
    box.scrollLeft = scrollLeft - walkX;
  });

  box.addEventListener('touchstart', (e) => {
    isDown = true;
    startX = e.touches[0].pageX - box.offsetLeft;
    scrollLeft = box.scrollLeft;
  });

  box.addEventListener('touchmove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.touches[0].pageX - box.offsetLeft;
    const walkX = (x - startX) * 1; // Adjust scroll speed here
    box.scrollLeft = scrollLeft - walkX;
  });

  box.addEventListener('touchend', () => {
    isDown = false;
  });
});

// set icons
const handleTours = document.querySelectorAll('.TabLink');
handleTours && handleTours.forEach(element => {
  let text = element.text.toUpperCase();
  if (text === 'ITINERARY') {
    element.insertAdjacentHTML('afterbegin', `<svg xmlns="http://www.w3.org/2000/svg" width="256" height="256" viewBox="0 0 256 256"><path  d="M208 32H48a16 16 0 0 0-16 16v160a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16m-90.34 117.66l-32 32a8 8 0 0 1-11.32 0l-16-16a8 8 0 0 1 11.32-11.32L80 164.69l26.34-26.35a8 8 0 0 1 11.32 11.32m0-64l-32 32a8 8 0 0 1-11.32 0l-16-16a8 8 0 0 1 11.32-11.32L80 100.69l26.34-26.35a8 8 0 0 1 11.32 11.32M192 168h-48a8 8 0 0 1 0-16h48a8 8 0 0 1 0 16m0-64h-48a8 8 0 0 1 0-16h48a8 8 0 0 1 0 16"/></svg>`)
  }// ITINERARY
  if (text === 'INCLUSIONS') {
    element.insertAdjacentHTML('afterbegin', `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 16 16"><path  fill-rule="evenodd" d="M5.28 2.22a.75.75 0 0 1 0 1.06l-2 2a.75.75 0 0 1-1.06 0l-1-1a.75.75 0 0 1 1.06-1.06l.47.47l1.47-1.47a.75.75 0 0 1 1.06 0M6.5 3.75c0 .414.336.75.75.75h7a.75.75 0 0 0 0-1.5h-7a.75.75 0 0 0-.75.75m.75 3.5a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5zm-1.97.03a.75.75 0 0 0-1.06-1.06L2.75 7.69l-.47-.47a.75.75 0 0 0-1.06 1.06l1 1a.75.75 0 0 0 1.06 0zm0 3.19a.75.75 0 0 1 0 1.06l-2 2a.75.75 0 0 1-1.06 0l-1-1a.75.75 0 1 1 1.06-1.06l.47.47l1.47-1.47a.75.75 0 0 1 1.06 0m1.97 1.03a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5z" clip-rule="evenodd"/></svg>`)///INCLUSIONS
  }
  if (text === "PRICE" || text === "PRICES" || text === "PRICE & AVAILABILITY") {
    element.insertAdjacentHTML('afterbegin', `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><path  d="M240 480v-36.42C160.53 439 112.25 398.06 112 336h72c1.77 26.34 23.86 46.45 56 50v-98l-26.77-7c-61-14.18-93.64-49.39-93.64-102.08C119.59 116.81 164.08 76.08 240 70V32h32v38c77.39 6.3 119 47.74 120 106h-72c-.76-24.06-15.83-43.39-48-46v92l30.82 7.28C367.61 243.46 400 277 400 332c0 64.34-43.74 105.88-128 111.32V480Zm0-264v-86c-27.59 1.52-47.27 18.47-47.27 42.53c0 22.3 16.39 36.88 47.27 43.47m32 78v92c38.15-1.54 56.38-18.92 56.38-45.77c0-24.58-18.23-41.13-56.38-46.23"/></svg>`)
  }// en Prices icons
  if (text === 'WHY SAM') {
    element.insertAdjacentHTML('afterbegin', `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path  d="M3 4v12c0 1.103.897 2 2 2h3.586L12 21.414L15.414 18H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2m2 0h14v12h-4.414L12 18.586L9.414 16H5z"/><path  d="m17.207 7.207l-1.414-1.414L11 10.586L8.707 8.293L7.293 9.707L11 13.414z"/></svg>`)
  }/// end why sam travel
  if (text == "IMPORTANT INFO" || text == "IMPORTANT INFORMATION") {
    element.insertAdjacentHTML('afterbegin', `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"><path  d="M20.108 15.754a1.11 1.11 0 0 0 1.107-1.107v-1.111c0-.606-.497-1.107-1.107-1.107s-1.109.502-1.109 1.107v1.111c0 .609.499 1.107 1.109 1.107m-2.215 4.431h1.106v6.278c0 .609.499 1.107 1.109 1.107s1.107-.498 1.107-1.107v-7.386a1.11 1.11 0 0 0-1.107-1.107h-2.215c-.61 0-1.109.498-1.109 1.107s.499 1.108 1.109 1.108m0 0"/><path  d="M33.847 34.847H6.153a1 1 0 0 1-1-1V6.153a1 1 0 0 1 1-1h27.693a1 1 0 0 1 1 1v27.693a1 1 0 0 1-.999 1.001m-26.694-2h25.693V7.153H7.153z"/></svg>`)
  } // enf important info
  if (text == "MAP") {
    element.insertAdjacentHTML('afterbegin', `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none"  stroke-width="2" d="M15 15h4l3 7H2l3-7h4m4-7a1 1 0 1 1-2 0a1 1 0 0 1 2 0M6 8c0 5 6 10 6 10s6-5 6-10c0-3.417-2.686-6-6-6S6 4.583 6 8Z"/></svg>`);
  }
  if (text == "PACKING CHECKLIST" || text == "PACKING LIST" || text == "PACKING CHECK LIST") {
    element.insertAdjacentHTML('afterbegin', `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path  d="M6.707 3.293a1 1 0 0 0-1.414 0L4 4.586l-.293-.293a1 1 0 0 0-1.414 1.414l1 1a1 1 0 0 0 1.414 0l2-2a1 1 0 0 0 0-1.414m14.296 13.7H10L9.883 17A1 1 0 0 0 10 18.993h11.003l.117-.006a1 1 0 0 0-.117-1.994m0-5.993H10l-.117.007A1 1 0 0 0 10 13h11.003l.117-.007A1 1 0 0 0 21.003 11m0-6H10l-.117.007A1 1 0 0 0 10 7h11.003l.117-.007A1 1 0 0 0 21.003 5M6.707 16.293a1 1 0 0 0-1.414 0L4 17.586l-.293-.293a1 1 0 0 0-1.414 1.414l1 1a1 1 0 0 0 1.414 0l2-2a1 1 0 0 0 0-1.414m-1.414-6.5a1 1 0 0 1 1.414 1.414l-2 2a1 1 0 0 1-1.414 0l-1-1a1 1 0 1 1 1.414-1.414l.293.293z"/></svg>`);
  }// end packing  list
  if (text == "OVERVIEW") {
    element.insertAdjacentHTML('afterbegin', `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 512 512" enable-background="new 0 0 512 512" style="&#10;  ">
      <g>
        <g>
          <path d="m34,256l26.2,26.2c108,108 283.7,108 391.7,0l26.1-26.2-26.2-26.2c-108-108-283.7-108-391.7,0l-26.1,26.2zm222,126.2c-75.8,0-151.6-28.9-209.3-86.6l-32.9-32.9c-3.7-3.7-3.7-9.7 0-13.5l32.9-32.9c115.4-115.4 303.2-115.4 418.6,0l32.9,32.9c3.7,3.7 3.7,9.7 0,13.5l-32.9,32.9c-57.7,57.7-133.5,86.6-209.3,86.6z"/>
          <path d="m256,183.5c-40,0-72.5,32.5-72.5,72.5s32.5,72.5 72.5,72.5c40,0 72.5-32.5 72.5-72.5s-32.5-72.5-72.5-72.5zm0,164c-50.5,0-91.5-41.1-91.5-91.5 0-50.5 41.1-91.5 91.5-91.5s91.5,41.1 91.5,91.5c0,50.5-41,91.5-91.5,91.5z"/>
        </g>
      </g>
    </svg>`)
  }
  if (text == 'SCHEDULE') {
    element.insertAdjacentHTML('afterbegin', `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path  d="M12 14a1 1 0 1 0-1-1a1 1 0 0 0 1 1m5 0a1 1 0 1 0-1-1a1 1 0 0 0 1 1m-5 4a1 1 0 1 0-1-1a1 1 0 0 0 1 1m5 0a1 1 0 1 0-1-1a1 1 0 0 0 1 1M7 14a1 1 0 1 0-1-1a1 1 0 0 0 1 1M19 4h-1V3a1 1 0 0 0-2 0v1H8V3a1 1 0 0 0-2 0v1H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3m1 15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9h16Zm0-11H4V7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1ZM7 18a1 1 0 1 0-1-1a1 1 0 0 0 1 1"/></svg>`
    )
  }
})
//  Sticky bottom by 
document.addEventListener("DOMContentLoaded", function () {
  var ur = document.getElementById("stickycontent");
  var stickyElement = document.querySelector(".sticky");

  window.addEventListener("scroll", function () {
    if (ur && stickyElement) {
      var urRect = ur.getBoundingClientRect();
      // console.log(urRect.top)
      if (urRect.top <= 0 && urRect.bottom >= window.innerHeight) {
        stickyElement.classList.add("isActive");
      } else {
        stickyElement.classList.remove("isActive");
      }
    }
  });
});






/*---------------- Code All tours Script--------------*/

const Loadtours = new Spinner({
  selector: '.spinner',
  width: 25,
  height: 25,
  text: 'loading..',
  color: "#6366f1",
  background: "#ffffff80",
})


const keyword = document.getElementById('geykeyword');
const day = document.getElementById('getday');
let minDollars = 45
let maxDollars = 4000
let minPrice = document.querySelector('#min');
let maxPrice = document.querySelector('#max');
const category = document.getElementById('changecategory');
if (keyword) {
  const filter = document.querySelectorAll('.filter');
  keyword.addEventListener('change', (e) => {
    ;
    Loadtours.active()
    setTimeout(() => {
      FilterText(keyword, filter)
      Loadtours.hide()
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      }); // Desplazar al principio
    }, 1000)
  })
  // change select category
  category.addEventListener('change', (e) => {
    Loadtours.active();
    setTimeout(() => {
      Filtercategy(category.value, filter)
      Loadtours.hide()
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      }); // Desplazar al principio
    }, 2000)
  })
  // change input filter max and min
  maxPrice.addEventListener('input', () => {
    Loadtours.active();
    let minValue = parseInt(minPrice.value)
    let maxValue = parseInt(maxPrice.value)
    if (maxValue < minValue + 10) {
      minPrice.value = maxValue - 10
      if (minValue === parseInt(minPrice.min)) {
        maxPrice.value = 10
      }
    }
    updateDollars()
    setTimeout(() => {
      filterPriceRange(filter)
      Loadtours.hide()
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      }); // Desplazar al principio
    }, 2000)
  })

  minPrice.addEventListener('input', () => {
    Loadtours.active();
    let minValue = parseInt(minPrice.value)
    let maxValue = parseInt(maxPrice.value)
    if (minValue > maxValue - 10) {
      maxPrice.value = minValue + 10
      if (maxValue === parseInt(maxPrice.max)) {
        minPrice.value = parseInt(maxPrice.max) - 10
      }
    }
    updateDollars()
    setTimeout(() => {
      filterPriceRange(filter)
      Loadtours.hide()
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      }); // Desplazar al principio
    }, 2000)
  })
}
// filter by  title
const FilterText = (input, filterData) => {
  let filter, keytext, el, i, hasfilter;
  keytext = input.value.toUpperCase();
  filter = filterData;
  for (i = 0; i < filter.length; i++) {
    el = filter[i].getElementsByTagName("h3")[0];
    if (el) {
      let isFilter = keytext.split(' ');
      var hasContent = 0;
      for (var filtro of isFilter) {
        if (el.innerHTML.toUpperCase().indexOf(filtro) > -1) {
          hasContent++;
        }
      }
      if (hasContent === isFilter.length) {
        filter[i].style.display = "";
        hasfilter = true;
      } else {
        filter[i].style.display = "none";
        hasfilter = false;
      }
    }
  }
}
/**
* filter categories
*/
const Filtercategy = (input, filterData) => {
  //   input:  keyword value 
  //   filter: query all data 
  // el: element for filter
  let filter, keytext, el, i, hasfilter;
  keytext = input.toUpperCase();

  filter = filterData;
  for (i = 0; i < filter.length; i++) {
    el = filter[i].getAttribute('category')
    if (el) {
      let isFilter = keytext.split(' ');
      var hasContent = 0;
      for (var filtro of isFilter) {
        if (el.toUpperCase().indexOf(filtro) > -1) {
          hasContent++;
        }
      }
      if (hasContent === isFilter.length) {
        filter[i].style.display = "";
        hasfilter = true;
      } else {
        filter[i].style.display = "none";
        hasfilter = false;
      }

    }
  }
}
// 

// filter by price
const filterPriceRange = (filterData) => {
  let minPrices = parseInt(document.querySelector('#min').value);
  let maxPrices = parseInt(document.querySelector('#max').value);
  console.log({ minPrices, maxPrices });

  if (isNaN(minPrices) || isNaN(maxPrices)) {
    return; // Exit the function if the input values are not valid numbers
  }
  for (let i = 0; i < filterData.length; i++) {
    let el = parseInt(filterData[i].getAttribute('price'));
    if (!isNaN(el)) {
      if (el >= minPrices && el <= maxPrices) {
        filterData[i].style.display = "";
      } else {
        filterData[i].style.display = "none";
      }
    }
  }
}

function numberWithSpaces(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}

function updateDollars() {
  let fromValue = minPrice.value;
  let toValue = maxPrice.value;
  document.querySelector('#from').textContent = `$${numberWithSpaces(Math.floor(fromValue))}`
  document.querySelector('#to').textContent = `$${numberWithSpaces(Math.floor(toValue))}`
}
// submit